<template>
  <div class="page_table_area operation">
    <!-- 岗位 -->
    <div class="tab_area">
      <el-tabs v-model="activeTabId" @tab-click="handleTabsClick">
        <el-tab-pane
          :label="item.name"
          :name="item.id"
          v-for="(item, index) in arrJobTypes"
          :key="index"
          >{{ item.name }}</el-tab-pane
        >
      </el-tabs>
    </div>
    <div class="scroll_area">
      <!-- 标题 -->
      <div class="table_title_area">
        <div class="left">
          合计：<span class="blue">{{ pageData.total }}条</span>
        </div>
        <el-button
          class="btn_create right"
          @click="btnCreateClick"
          v-if="pms.create"
        >
          <div class="btn_content">
            <div class="icon-create"></div>
            <div class="text_create">新建</div>
          </div>
        </el-button>
      </div>
      <!-- 表格 -->
      <div class="table_area">
        <el-table :data="tableData">
          <el-table-column :width="4 * docFontSize"></el-table-column>
          <el-table-column
            label="创建日期"
            prop="createTime"
            :width="14 * docFontSize"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | filterCreateDate }}
            </template>
          </el-table-column>
          <el-table-column
            label="单位简称"
            prop="unitShortName"
            :width="18 * docFontSize"
          ></el-table-column>
          <el-table-column
            label="登录帐号"
            prop="name"
            :width="16 * docFontSize"
          ></el-table-column>
          <el-table-column
            label="使用者"
            prop="nick"
            :width="16.6 * docFontSize"
          ></el-table-column>
          <el-table-column
            label="手机号"
            prop="tel"
            :width="16 * docFontSize"
          ></el-table-column>
          <el-table-column
            label="企业微信账号"
            prop="enterpriseMobile"
            :width="16 * docFontSize"
          ></el-table-column>
          <el-table-column label="状态" prop="state" :width="13 * docFontSize">
            <template slot-scope="scope">
              {{ scope.row.state | accountState }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" v-if="scope.row.createTime">
              <!-- 状态：0停用、1启用、2解绑 -->
              <el-button
                type="text"
                @click="btnEditClick(scope.row)"
                :disabled="scope.row.state != 1"
                v-if="pms.edit"
                >编辑</el-button
              >
              <el-button
                type="text"
                @click="btnUseClick(scope.row)"
                v-if="
                  (scope.row.state == 0 || scope.row.state == 2) && pms.reuse
                "
                >启用</el-button
              >
              <el-button
                type="text"
                class="red"
                @click="btnStopClick(scope.row)"
                v-if="scope.row.state == 1 && pms.stop"
                >停用</el-button
              >
              <el-button
                type="text"
                @click="btnUnbindClick(scope.row)"
                v-if="scope.row.state == 0 && pms.unbind"
                >解绑</el-button
              >
              <el-button
                type="text"
                disabled
                v-if="
                  (scope.row.state == 1 || scope.row.state == 2) && pms.unbind
                "
                >解绑</el-button
              >
              <el-button
                type="text"
                class="red"
                @click="btnDeleteClick(scope.row)"
                v-if="
                  (scope.row.state == 0 || scope.row.state == 2) && pms.delete
                "
                >删除</el-button
              >
              <el-button
                type="text"
                disabled
                v-if="scope.row.state == 1 && pms.delete"
                >删除</el-button
              >

              <!-- <el-button
                type="text"
                @click="btnRelationship(scope.row)"
                v-if="activeType == '3' && pms.relation"
                >确定用户关系</el-button
              > -->
            </template>
          </el-table-column>
          <template slot="empty">
            <table-empty></table-empty>
          </template>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination_area">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageData.page"
          :page-sizes="[20, 50, 100]"
          :page-size="pageData.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TableEmpty from "../../../../components/TableEmpty.vue";
import mixins from "./Mixins";
export default {
  components: { TableEmpty },
  mixins: [mixins],
  data() {
    return {
      pms: {
        create: false,
        edit: false,
        stop: false,
        unbind: false,
        reuse: false,
        delete: false,
        relation: false,
      },
    };
  },
  computed: {
    arrJobTypes() {
      return this.Operation.arrJobTypes;
    },
    activeTabId: {
      get() {
        return this.Operation.activeTabId;
      },
      set(v) {
        this.SETOPTIONS({
          activeTabId: v,
        });
      },
    },
    activeType: {
      get() {
        return this.Operation.activeType;
      },
      set(v) {
        this.SETOPTIONS({
          activeType: v,
        });
      },
    },
    tableData() {
      return this.Operation.tableData;
    },
    pageData() {
      return this.Operation.pageData;
    },
  },
  filters: {
    accountState(v) {
      if (v == 0) {
        return "停用";
      } else if (v == 1) {
        return "启用";
      } else if (v == 2) {
        return "解绑";
      } else {
        return "";
      }
    },
    filterCreateDate(v) {
      if (v && v.indexOf(" ") >= 0) {
        return v.split(" ")[0];
      } else {
        return "";
      }
    },
  },
  watch: {
    activeTabId(v) {
      this.getTableList_A();
    },
  },
  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms.create = pms["40100"].check;
    this.pms.edit = pms["40200"].check;
    this.pms.stop = pms["40300"].check;
    this.pms.unbind = pms["40400"].check;
    this.pms.reuse = pms["40500"].check;
    this.pms.delete = pms["40600"].check;
    //this.pms.relation = pms["40700"].check;
    this.getJobList_A();
  },
  methods: {
    handleTabsClick(v) {
      this.SETOPTIONS({
        activeTabLabel: v.label,
        activeType: this.Operation.arrJobTypes[v.index].type,
      });
    },
    handleSizeChange() {
      this.getTableList_A();
    },
    handleCurrentChange() {
      this.getTableList_A();
    },
    btnCreateClick() {
      this.getUnitListForCreate_A();
      this.SETOPTIONS({
        createData: {
          unitId: "",
          nick: "",
          tel: "",
          enterpriseMobile: "",
          coverUrl: "",
        },
        showCreateDialog: true,
      });
    },
    btnEditClick(row) {
      console.log(row)
      this.getUnitListForCreate_A();
      this.SETOPTIONS({
        createData: {
          id: row.id,
          unitId: row.unitId.toString(),
          name: row.name,
          unitName: row.unitName,
          unitShortName: row.unitShortName,
          nick: row.nick,
          tel: row.tel,
          resetPwd: false,
          enterpriseMobile:
            row.enterpriseMobile != "—" ? row.enterpriseMobile : "",
          coverUrl: row.enterpriseCardUrl != undefined ? row.enterpriseCardUrl : "",
        },
        showCreateDialog: true,
      });
    },
    async btnUseClick(row) {
      if (row.state == 2) {
        this.getUnitListForCreate_A();
        this.SETOPTIONS({
          createData: {
            id: row.id,
            unitId: row.unitId.toString(),
            name: row.name,
            unitName: row.unitName,
            unitShortName: row.unitShortName,
            nick: row.nick,
            tel: row.tel,
            resetPwd: false,
            isReuse: true,
            enterpriseMobile:
              row.enterpriseMobile != "—" ? row.enterpriseMobile : "",
            coverUrl: row.enterpriseCardUrl != undefined ? row.enterpriseCardUrl : "",
          },
          showCreateDialog: true,
        });
      } else if (row.state == 0) {
        let result = await this.stopOrReuseAccount_A(row.id);
        if (result) {
          this.getTableList_A();
          this.$Message.success("操作成功");
        }
      }
    },
    btnStopClick(row) {
      this.$Confirm("停用后该帐号将无法登录，确定要停用该帐号吗？", "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal: false,
      })
        .then(async () => {
          let result = await this.stopOrReuseAccount_A(row.id);
          if (result) {
            this.getTableList_A();
            this.$Message.success("操作成功");
          }
        })
        .catch(() => {});
    },
    btnUnbindClick(row) {
      let htmlStr = "";
      if (row.enterpriseMobile != "—") {
        htmlStr = `<div>确定解绑<span style='color:#4EA2FF;font-size:2rem;'> ${row.tel.substr(
          0,
          3
        )} ${row.tel.substr(3, 4)} ${row.tel.substr(
          7,
          4
        )} </span>，姓名<span style='color:#4EA2FF;font-size:2rem;'> ${
          row.nick
        } </span>，企业微信号<span style='color:#4EA2FF;font-size:2rem;'> ${row.enterpriseMobile.substr(
          0,
          3
        )} ${row.enterpriseMobile.substr(3, 4)} ${row.enterpriseMobile.substr(
          7,
          4
        )} </span>吗</div>`;
      } else {
        htmlStr = `<div>确定解绑<span style='color:#4EA2FF;font-size:2rem;'> ${row.tel.substr(
          0,
          3
        )} ${row.tel.substr(3, 4)} ${row.tel.substr(
          7,
          4
        )} </span>，姓名<span style='color:#4EA2FF;font-size:2rem;'> ${
          row.nick
        } </span>`;
      }
      this.$Confirm(htmlStr, "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      })
        .then(async () => {
          let result = await this.unbindAcount_A(row.id);
          if (result) {
            this.getTableList_A();
            this.$Message.success("操作成功");
          }
        })
        .catch(() => {});
      // unbindAcount_A
    },
    btnDeleteClick(row) {
      this.$Confirm("删除后该帐号将无法使用，确定要删除该帐号吗？", "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal: false,
      })
        .then(async () => {
          let result = await this.deleteAccount_A(row.id);
          if (result) {
            this.getTableList_A();
            this.$Message.success("操作成功");
          }
        })
        .catch(() => {});
    },
    btnRelationship(row) {
      this.confirmEnterpriseCustomer(row.id).then((res) => {
        if (res) {
          this.getTableList_A();
          this.$Message.success("操作成功");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.page_table_area {
  top: 248px;
}

.page_table_area.operation {
  .tab_area {
    height: 69px;
    margin: 0 30px;
    border-bottom: 1px solid #CCD7EA;
  }

  .scroll_area {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 70px;
    overflow-y: overlay;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/OperationAccount/components/accountTable.vue